import script from "./InitiativeShortForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./InitiativeShortForm.vue?vue&type=script&lang=ts&setup=true"

import "./InitiativeShortForm.vue?vue&type=style&index=0&id=1478a53c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1478a53c"]])

export default __exports__